(() => {
  const wireCollection = () => {
    const page = document.querySelector('.collection-page');
    if (!page || page.dataset.shoppingReady) return;
    page.dataset.shoppingReady = 'true';
    const params = new URLSearchParams(location.search);
    const sort = params.get('sort_by') || 'created-descending';
    // Virtual departments merge several source collections; order that merged grid by creation date.
    if (!['created-descending', 'created-ascending', 'price-ascending', 'price-descending'].includes(sort)) return;
    const orderGrid = (grid) => {
      if (grid.dataset.viewRankManaged === 'true') return;
      const cards = Array.from(grid.children).filter((card) => card.matches('.product-card'));
      const ordered = [...cards].sort((a, b) => {
        if (sort.startsWith('price-')) {
          const priceDelta = Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
          return sort === 'price-ascending' ? priceDelta : -priceDelta;
        }
        const delta = Number(b.dataset.productCreatedAt || 0) - Number(a.dataset.productCreatedAt || 0);
        return sort === 'created-ascending' ? -delta : delta;
      });
      if (ordered.every((card, index) => card === cards[index])) return;
      ordered.forEach((card) => grid.append(card));
    };
    page.querySelectorAll('[data-product-grid]').forEach((grid) => {
      orderGrid(grid);
      const observer = new MutationObserver(() => orderGrid(grid));
      observer.observe(grid, { childList: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(page)) observer.disconnect();
      }, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireCollection, { once: true });
  else wireCollection();
  document.addEventListener('shopify:section:load', wireCollection);
})();

(() => {
  const mobile = window.matchMedia("(max-width: 990px)");
  const wireCategories = () => {
    document.querySelectorAll(".collection-page .gear-type-quick-filter").forEach((categories) => {
      if (categories.dataset.mobileCategoriesReady) return;
      categories.dataset.mobileCategoriesReady = "true";
      const summary = categories.querySelector("summary");
      if (summary && !summary.querySelector(".gear-type-quick-filter__mobile-label")) {
        const label = document.createElement("span");
        label.className = "gear-type-quick-filter__mobile-label";
        label.textContent = "Categories";
        summary.prepend(label);
      }
      if (mobile.matches) categories.open = false;
      categories.addEventListener("click", (event) => {
        if (mobile.matches && event.target.closest(".gear-type-quick-filter__menu a")) categories.open = false;
      });
      categories.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && categories.open) {
          categories.open = false;
          summary?.focus();
        }
      });
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wireCategories, { once: true });
  else wireCategories();
  document.addEventListener("shopify:section:load", wireCategories);
})();

// Product image viewer. PhotoSwipe owns zoom, pan, touch gestures and focus trapping.
(() => {
  const bases = [
    'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/',
    'https://unpkg.com/photoswipe@5.4.4/dist/'
  ];
  let library;
  let opening = false;
  let viewer;
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const galleryImageSelector = '[data-product-gallery] [data-zoom-image]';
  let hoverLens;
  let hoverPoint;
  let hoverFrame = 0;
  let hoverSource;
  const hideHoverZoom = () => {
    cancelAnimationFrame(hoverFrame);
    hoverFrame = 0;
    hoverPoint = null;
    if (hoverLens) hoverLens.hidden = true;
  };
  const renderHoverZoom = () => {
    hoverFrame = 0;
    if (!hoverPoint || !hoverQuery.matches || opening || viewer) return hideHoverZoom();
    const { trigger, x, y } = hoverPoint;
    const img = trigger.querySelector('img');
    if (!trigger.isConnected || !img?.complete || !img.naturalWidth) return hideHoverZoom();

    // Match the contained photo, including the gallery's existing scale and centering.
    const rect = img.getBoundingClientRect();
    const scale = Math.min(rect.width / img.naturalWidth, rect.height / img.naturalHeight);
    const width = img.naturalWidth * scale;
    const height = img.naturalHeight * scale;
    const imageLeft = rect.left + (rect.width - width) / 2;
    const imageTop = rect.top + (rect.height - height) / 2;
    if (!width || !height || x < imageLeft || x > imageLeft + width || y < imageTop || y > imageTop + height) return hideHoverZoom();

    if (!hoverLens) {
      hoverLens = document.createElement('div');
      hoverLens.className = 'product-hover-zoom';
      hoverLens.setAttribute('aria-hidden', 'true');
      hoverLens.hidden = true;
      document.body.append(hoverLens);
    }
    const source = JSON.stringify(new URL(trigger.dataset.zoomImage, location.href).href);
    const preview = JSON.stringify(img.currentSrc || img.src);
    const background = `url(${source}), url(${preview})`;
    if (hoverSource !== background) {
      // The already-loaded photo remains underneath while its high-resolution copy loads.
      hoverLens.style.backgroundImage = background;
      hoverSource = background;
    }
    const size = Math.min(240, window.innerWidth - 24, window.innerHeight - 24);
    const left = Math.max(8, Math.min(x - size / 2, window.innerWidth - size - 8));
    const top = Math.max(8, Math.min(y - size / 2, window.innerHeight - size - 8));
    const zoom = 2.5;
    hoverLens.style.width = `${size}px`;
    hoverLens.style.height = `${size}px`;
    hoverLens.style.left = `${left}px`;
    hoverLens.style.top = `${top}px`;
    hoverLens.style.backgroundSize = `${width * zoom}px ${height * zoom}px`;
    hoverLens.style.backgroundPosition = `${x - left - (x - imageLeft) * zoom}px ${y - top - (y - imageTop) * zoom}px`;
    hoverLens.hidden = false;
  };
  document.addEventListener('pointermove', (event) => {
    const trigger = event.target.closest?.(galleryImageSelector);
    if (!trigger || event.pointerType !== 'mouse' || event.buttons || !hoverQuery.matches || opening || viewer) return hideHoverZoom();
    hoverPoint = { trigger, x: event.clientX, y: event.clientY };
    if (!hoverFrame) hoverFrame = requestAnimationFrame(renderHoverZoom);
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (hoverPoint && !hoverPoint.trigger.contains(event.relatedTarget)) hideHoverZoom();
  });
  document.addEventListener('pointerdown', hideHoverZoom, { passive: true });
  document.addEventListener('pointercancel', hideHoverZoom, { passive: true });
  document.addEventListener('dragstart', hideHoverZoom);
  document.addEventListener('scroll', hideHoverZoom, { capture: true, passive: true });
  document.addEventListener('visibilitychange', hideHoverZoom);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hideHoverZoom();
  });
  window.addEventListener('resize', hideHoverZoom, { passive: true });
  window.addEventListener('blur', hideHoverZoom);
  hoverQuery.addEventListener('change', hideHoverZoom);
  const timeout = (promise, ms) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Image viewer load timed out')), ms);
    promise.then(resolve, reject).finally(() => clearTimeout(timer));
  });
  const loadStyles = (base) => new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${base}photoswipe.css`;
    link.onload = () => resolve(link);
    link.onerror = () => { link.remove(); reject(new Error('Image viewer styles unavailable')); };
    document.head.append(link);
  });
  const loadViewer = () => {
    if (!library) library = (async () => {
      for (const base of bases) {
        try {
          const [module] = await timeout(Promise.all([
            import(`${base}photoswipe.esm.min.js`), loadStyles(base)
          ]), 7000);
          return module.default;
        } catch (_) { /* Try the second pinned distribution before the original-image fallback. */ }
      }
      library = null;
      throw new Error('Image viewer unavailable');
    })();
    return library;
  };
  const wireZoom = () => {
    if (!document.querySelector('[data-product-gallery] [data-zoom-image]')) return;
    if (!document.getElementById('gearonimo-product-zoom-style')) {
      const style = document.createElement('style');
      style.id = 'gearonimo-product-zoom-style';
      style.textContent = `.pswp { z-index: 2147483647; }
        .pswp .pswp__img { background: #fff; max-width: none; max-height: none; }
        .pswp .pswp__button { border-radius: 0; }
        .pswp .pswp__top-bar { background: #111; }
        .pswp .pswp__button--arrow { background: #111; border-radius: 4px; width: 50px; height: 60px; margin: 0 8px; }
        [data-product-gallery] [data-zoom-image]:focus-visible { outline: 3px solid #f45a00; outline-offset: -4px; }
        [data-product-gallery] [data-zoom-image][aria-busy="true"] { cursor: progress; }
        .product-hover-zoom {
          position: fixed; z-index: 1000; pointer-events: none;
          padding: 0; border: 0; border-radius: 4px; outline: 1px solid #333;
          background-color: #fff; background-repeat: no-repeat;
          box-shadow: 0 4px 18px rgb(0 0 0 / 24%);
        }
        .product-hover-zoom[hidden] { display: none !important; }
        @media (hover: none), (pointer: coarse) { .product-hover-zoom { display: none !important; } }`;
      document.head.append(style);
    }
  };
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest?.('[data-product-gallery] [data-zoom-image]');
    if (!trigger || event.button > 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    event.preventDefault();
    if (opening || viewer) return;
    hideHoverZoom();
    opening = true;
    trigger.setAttribute('aria-busy', 'true');
    const gallery = trigger.closest('[data-product-gallery]');
    const slides = [...gallery.querySelectorAll('[data-zoom-image]')].filter(slide => slide.querySelector('img'));
    const dataSource = slides.map(slide => {
      const img = slide.querySelector('img');
      return {
        src: new URL(slide.dataset.zoomImage, location.href).href,
        width: Number(img.getAttribute('width')) || img.naturalWidth || 1100,
        height: Number(img.getAttribute('height')) || img.naturalHeight || 1100,
        alt: img.alt,
        msrc: img.currentSrc || img.src
      };
    });
    try {
      const PhotoSwipe = await loadViewer();
      if (!trigger.isConnected) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const overflow = document.documentElement.style.overflow;
      viewer = new PhotoSwipe({
        dataSource, index: Math.max(0, slides.indexOf(trigger)),
        bgOpacity: 1, showHideAnimationType: reduced ? 'none' : 'fade',
        showAnimationDuration: 180, hideAnimationDuration: 180,
        zoomAnimationDuration: reduced ? 0 : 200,
        wheelToZoom: true, initialZoomLevel: 'fit',
        secondaryZoomLevel: level => Math.max(1, level.fit * 2.5),
        maxZoomLevel: level => Math.max(2, level.fit * 5),
        imageClickAction: 'zoom', doubleTapAction: 'zoom',
        pinchToClose: false, closeOnVerticalDrag: false,
        allowPanToNext: false, returnFocus: false,
        padding: { top: 60, bottom: 20, left: 12, right: 12 }
      });
      viewer.on('destroy', () => {
        document.documentElement.style.overflow = overflow;
        const active = slides[viewer.currIndex];
        viewer = null;
        if (active?.isConnected) active.focus?.({ preventScroll: true });
      });
      viewer.on('change', () => {
        const active = slides[viewer.currIndex];
        if (!active) return;
        const index = active.dataset.gallerySlide;
        gallery.querySelectorAll('[data-gallery-slide], [data-gallery-thumb]').forEach(node => {
          node.classList.toggle('is-active', (node.dataset.gallerySlide ?? node.dataset.galleryThumb) === index);
        });
      });
      document.documentElement.style.overflow = 'hidden';
      viewer.init();
    } catch (_) {
      viewer?.destroy();
      viewer = null;
      // The full-resolution photo remains accessible if both library CDNs fail.
      location.assign(new URL(trigger.dataset.zoomImage, location.href).href);
    } finally {
      opening = false;
      trigger.removeAttribute('aria-busy');
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireZoom, { once: true });
  else wireZoom();
  document.addEventListener('shopify:section:load', wireZoom);
  document.addEventListener('shopify:section:unload', () => {
    hideHoverZoom();
    viewer?.destroy();
  });
})();
